var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.462,
    height: 25.75,
    viewBox: "0 0 24.462 25.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #7d7d7d;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #7d7d7d;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-miterlimit: 10;\n        stroke-width: 1.5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11291",
    "data-name": "Group 11291",
    transform: "translate(-987.25 -3923.25)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1827",
    "data-name": "Ellipse 1827",
    className: "cls-1",
    cx: 1.998,
    cy: 1.998,
    r: 1.998,
    transform: "translate(997.34 3945.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7152",
    "data-name": "Path 7152",
    className: "cls-1",
    d: "M16.853,31.93c-.352.5-.7.992-1.094,1.45a.973.973,0,0,1-1.251.267,1.777,1.777,0,0,0-1.329,0,1.131,1.131,0,0,1-1.563-.42,4.4,4.4,0,0,1-1.016-2.71,2.055,2.055,0,0,1,1.563-2.1,2.2,2.2,0,0,1,.86.076,2.1,2.1,0,0,0,1.524,0,1.709,1.709,0,0,1,1.993.573A1.608,1.608,0,0,0,16.853,31.93Z",
    transform: "translate(980.607 3905.053)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7153",
    "data-name": "Path 7153",
    className: "cls-1",
    d: "M42.879,32.79c.508-1.45,1.016-2.9,1.524-4.39h1.055c-.039.076-.039.191-.078.267-.664,1.641-1.329,3.283-1.954,4.924a.342.342,0,0,1-.352.229c-.7,0-.7,0-.938-.649-.586-1.489-1.172-3.015-1.759-4.5A2.389,2.389,0,0,1,40.3,28.4h.938c.078,0,.117.115.156.191C41.863,30,42.371,31.377,42.879,32.79Z",
    transform: "translate(962.514 3905.033)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7154",
    "data-name": "Path 7154",
    className: "cls-1",
    d: "M30.143,25.367c.352-.076.664-.191,1.016-.267v1.221H32.6v.763H31.237a.117.117,0,0,0-.039.076c0,1.031,0,2.061.039,3.092,0,.611.274.8.86.763a1.793,1.793,0,0,0,.43-.038c.039.229.039.5.078.8a6.839,6.839,0,0,1-1.251,0,1.324,1.324,0,0,1-1.133-1.489V27.085H29.4v-.763h.821A3.785,3.785,0,0,1,30.143,25.367Z",
    transform: "translate(969.154 3907.073)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7155",
    "data-name": "Path 7155",
    className: "cls-1",
    d: "M18.214,25.7c-.274-.573.508-1.6,1.407-1.6A1.4,1.4,0,0,1,18.214,25.7Z",
    transform: "translate(976.003 3907.692)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7156",
    "data-name": "Path 7156",
    className: "cls-2",
    d: "M7.676,23.727H5.169A4.374,4.374,0,0,1,.7,19.448V5.044A4.415,4.415,0,0,1,5.169.8H19.193a4.374,4.374,0,0,1,4.469,4.279v14.4a4.374,4.374,0,0,1-4.469,4.279H16.722",
    transform: "translate(987.3 3923.2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleTv);
export default __webpack_public_path__ + "static/media/appleTv.9a642d20fc2ba574546e5afd7a2995a1.svg";
export { ForwardRef as ReactComponent };